import {
    GdprAdsPrefsOptions,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import { generateConsentString } from 'owa-gdpr-ad-consent-string';
import getOptions from '../selectors/getOptions';
import { trace } from 'owa-trace';

export default async function() {
    const options = getOptions();

    const consentString = await generateConsentString(
        options.allowAccess,
        options.allowPersonalization,
        options.allowAdSelection,
        options.allowContentSelection,
        options.allowMeasurement
    );

    if (!consentString) {
        trace.error('Generating consent string failed.');
    }

    const savedOptions = getOptionsForFeature<GdprAdsPrefsOptions>(
        OwsOptionsFeatureType.GdprAdsPrefs
    );

    const newOptions = {
        ...savedOptions,
        allowStorageAndAccess: options.allowAccess,
        allowAdSelectionDeliveryReporting: options.allowAdSelection,
        allowContentSelectionDeliveryReporting: options.allowContentSelection,
        allowPersonalization: options.allowPersonalization,
        allowMeasurement: options.allowMeasurement,
        ...(consentString ? { consentString: consentString } : null),
    };

    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.GdprAdsPrefs,
        newOptions
    );
}
